import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { isMobile, isTablet } from "react-device-detect";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 1, // optional, default to 1.
        partialVisibilityGutter: 40,
    },
    tablet: {
        breakpoint: { max: 1024, min: 700 },
        items: 2,
        slidesToSlide: 1,// optional, default to 1.
        partialVisibilityGutter: 40,
    },
    mobile: {
        breakpoint: { max: 700, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
        partialVisibilityGutter: 40,
    }
};


type Props<T extends { id: string | number }> = {
    items: T[];
    center_mode?: boolean;
    partially_visible?: boolean;
    no_infinite?: boolean;
    renderItem: (item: T, idx: number) => React.ReactNode;
    rows?: number;
}

export const EdSlider = <T extends { id: string | number }>({
    items,
    center_mode,
    partially_visible,
    renderItem,
    no_infinite,
    rows = 1,
}: Props<T>) => {
    const classes = useStyles({});

    return <Carousel
        swipeable={true}
        draggable={false}
        showDots={false}
        responsive={responsive}
        infinite={!no_infinite}
        arrows={isMobile || isTablet ? false : true}
        autoPlay={false}
        keyBoardControl={true}
        transitionDuration={700}
        partialVisible={partially_visible}
        centerMode={center_mode}
        containerClass={classes.container}>
        {items.map((video, idx) => <div
            style={{
                textAlign: 'left',
                marginLeft: 4,
                marginRight: 4,
                height: '100%',
            }}
            key={video.id}>
            {renderItem(video, idx)}
        </div>)}

    </Carousel>;
}


const useStyles = makeStyles(theme => createStyles({
    container: {
        marginLeft: -4,
        marginRight: -4,
        '& .react-multiple-carousel__arrow--left': {
            left: 0,
            top: '40%',
            minWidth: 30,
            minHeight: 30,
            zIndex: 99,
            '&::before': {
                fontSize: 16,
            }
        },
        '& .react-multiple-carousel__arrow--right': {
            right: 0,
            top: '40%',
            minWidth: 30,
            minHeight: 30,
            zIndex: 99,
            '&::before': {
                fontSize: 16,
            }
        }
    },
}))